export const WEBSITE_URL = 'https://www.content-sync.io';

export const CONTACT_URL = `${WEBSITE_URL}/contact/`;
export const IMPRINT_URL = `${WEBSITE_URL}/imprint/`;
export const PRIVACY_URL = `${WEBSITE_URL}/privacy-policy/`;
export const TERMS_AND_CONDITIONS_URL = `${WEBSITE_URL}/tos/`;

export const API_DOMAIN = `${process.env.REACT_APP_API_DOMAIN}`;
